import { apiFetch, API_BASE_URL, API_ORIGIN, ApiError, parseError } from '../http';
import { camelizeKeys, dualizeKeys } from '../normalize';
import { getAccessToken, getRefreshToken, setSession, clearSession } from '../session';
import { queryCache } from '../queryCache';

type ReqOptions = {
  method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  body?: unknown;
  auth?: boolean;
  query?: Record<string, string | number | boolean | undefined | null>;
};

export { API_BASE_URL, API_ORIGIN, ApiError };

export const tokenStore = {
  get access() { return getAccessToken(); },
  get refresh() { return getRefreshToken(); },
  set: (access: string, refresh: string) => setSession({ accessToken: access, refreshToken: refresh }),
  clear: () => clearSession(),
};

/**
 * Admin/API request wrapper. Bodies are camelized to match the backend
 * validators; responses expose both casings so callers can read either.
 */
export async function api<T = unknown>(path: string, opts: ReqOptions = {}): Promise<T> {
  const { method = 'GET', body, auth = true, query } = opts;
  const payload = body === undefined ? undefined : camelizeKeys(body);
  const res = await apiFetch<T>(path, { method, body: payload, auth, query });
  if (method !== 'GET') {
    queryCache.clear();
  }
  return dualizeKeys<T>(res);
}


/** Raw binary GET (invoice PDFs, exports). */
export async function apiBlob(path: string): Promise<Blob> {
  const token = getAccessToken();
  const headers: Record<string, string> = {};
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const url = `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
  const res = await fetch(url, { headers });
  if (!res.ok) throw await parseError(res);
  return res.blob();
}
